module.exports = {"chart":{"type":"multiBarChart","showValues":false,"showControls":false,"showLegend":false,"tooltip":{"enabled":true},"xAxis":{"rotateYLabel":false,"showMaxMin":false},"yAxis":{"showMaxMin":false},"height":200,"noData":""}}


//////////////////
// WEBPACK FOOTER
// ./src/modules/dashboard/components/dashboard-widget/self-service-out-of-stock/self-service-out-of-stock-chart-config.json
// module id = 1660
// module chunks = 0